import proxy from './proxy.png'

const content = `<p>The Proxy design pattern has the same structure as <a href="/decorator">Decorator</a> in that it is an object that calls another object and exposes the same interface.</p>

<img src=${proxy} alt="proxy" />

<p>But the two patterns have a different intent: Decorator augments the features of the decorated object, whereas Proxy hide technical details is the access of the proxied object. Typical examples of such technical details are:</p>

<ul><li>lazy loading of the subject (the first call to the proxy instantiates the subject and caches it in the proxy)</li><li>access control on the subject (the proxy checks that the client has the right to access the subject)</li></ul>

<p>Since the proxy and the subject share the same interface, the client doesn’t know that it’s calling a proxy. It uses <a href="/polymorphism">Polymorphism</a> to achieve <a href="/low-coupling">Low coupling</a> between the technical details and the rest of the code.</p>`

export default content
